const AVATAR_COUNT = 12;

/** Avatar padrão para mensagens do cliente (contato) quando não há foto. */
export function getDefaultAvatar(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return `/avatars/avatar${(hash % AVATAR_COUNT) + 1}_azul.png`;
}

/** Avatar padrão para operadores/atendentes quando não há foto de perfil na plataforma. */
export function getDefaultOperatorAvatar(): string {
  return "/avatars/default-operator.png";
}
